import { render, staticRenderFns } from "./AuditoriaMatriculas.vue?vue&type=template&id=85546012"
import script from "./AuditoriaMatriculas.vue?vue&type=script&lang=js"
export * from "./AuditoriaMatriculas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports